import { useState, useEffect } from 'react';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import FeaturesSection from './components/FeaturesSection';
import FaqSection from './components/FaqSection';
import CarouselSection from './components/CarouselSection';
import CardsSection from './components/CardsSection';
import UpdatesSection from './components/UpdatesSection';
import AppSection from './components/AppSection';
import RankingSection from './components/RankingSection';
import ContactSection from './components/ContactSection';
import MediaSection from './components/MediaSection';
import CommentsSection from './components/CommentsSection';
import TopicsSection from './components/TopicsSection';
import IndexSection from './components/IndexSection';

const navLinks = [
  { href: '#about', label: '平台介绍' },
  { href: '#carousel', label: '焦点专题' },
  { href: '#cards', label: '每日爆料' },
  { href: '#ranking', label: '热门榜单' },
  { href: '#comments', label: '读者热议' },
];

export default function Home() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setMobileMenuOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="min-h-screen bg-background-50">
      {/* Header */}
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled
            ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
            : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="flex items-center justify-between h-16">
            {/* Logo */}
            <a
              href="#hero"
              onClick={(e) => handleNavClick(e, '#hero')}
              className="flex items-center gap-2 cursor-pointer"
            >
              <span className="text-xl md:text-2xl font-heading text-primary-500 whitespace-nowrap">
                每日大赛mrds
              </span>
            </a>

            {/* Desktop Nav */}
            <nav className="hidden md:flex items-center gap-1">
              <a
                href="#hero"
                onClick={(e) => handleNavClick(e, '#hero')}
                className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 rounded-full hover:bg-primary-50 transition-colors duration-200 cursor-pointer whitespace-nowrap"
              >
                首页
              </a>
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => handleNavClick(e, link.href)}
                  className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 rounded-full hover:bg-primary-50 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                >
                  {link.label}
                </a>
              ))}
            </nav>

            {/* Mobile hamburger */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden w-10 h-10 flex items-center justify-center rounded-full hover:bg-background-200 transition-colors cursor-pointer"
              aria-label="Toggle menu"
            >
              <i className={`text-xl text-foreground-700 ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        {mobileMenuOpen && (
          <div className="md:hidden bg-background-50 border-b border-background-200/70">
            <nav className="max-w-7xl mx-auto px-4 py-4 flex flex-col gap-2">
              <a
                href="#hero"
                onClick={(e) => handleNavClick(e, '#hero')}
                className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-primary-50 rounded-xl transition-colors duration-200 cursor-pointer"
              >
                首页
              </a>
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => handleNavClick(e, link.href)}
                  className="px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-500 hover:bg-primary-50 rounded-xl transition-colors duration-200 cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </nav>
          </div>
        )}
      </header>

      {/* Main Content */}
      <main>
        <HeroSection />
        <AboutSection />
        <FeaturesSection />
        <FaqSection />
        <CarouselSection />
        <CardsSection />
        <UpdatesSection />
        <AppSection />
        <RankingSection />
        <ContactSection />
        <MediaSection />
        <CommentsSection />
        <TopicsSection />
        <IndexSection />
      </main>

      {/* Footer */}
      <footer id="footer" className="bg-foreground-900 text-background-50/80 pt-14 md:pt-20 pb-8 px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
            {/* Brand */}
            <div>
              <h3 className="text-lg font-heading text-background-50 mb-3">每日大赛mrds</h3>
              <p className="text-sm text-background-50/60 leading-relaxed">
                汇聚mrds热门话题与每日爆料，大赛每日更新新瓜，榜单揭晓黑料与擦边搞笑内容随时刷新。你的每日娱乐资讯第一站。
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-sm font-medium text-background-50 mb-4">快速导航</h4>
              <div className="flex flex-col gap-2.5">
                {navLinks.map((link) => (
                  <a
                    key={link.href}
                    href={link.href}
                    onClick={(e) => handleNavClick(e, link.href)}
                    className="text-sm text-background-50/50 hover:text-primary-400 transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </a>
                ))}
              </div>
            </div>

            {/* Topics */}
            <div>
              <h4 className="text-sm font-medium text-background-50 mb-4">热门话题</h4>
              <div className="flex flex-wrap gap-2">
                {['每日大赛新瓜', '榜单揭晓', '黑料深扒', '擦边搞笑', '匿名爆料', '综艺翻车'].map((t) => (
                  <a
                    key={t}
                    href="#topics"
                    onClick={(e) => handleNavClick(e, '#topics')}
                    className="text-xs text-background-50/50 bg-background-50/10 px-2.5 py-1 rounded-full hover:bg-primary-500/20 hover:text-primary-400 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                  >
                    #{t}
                  </a>
                ))}
              </div>
            </div>

            {/* Partners */}
            <div>
              <h4 className="text-sm font-medium text-background-50 mb-4">合作伙伴</h4>
              <p className="text-xs text-background-50/40 leading-relaxed">
                期待与更多优质平台建立合作关系，共同打造更好的内容生态。
              </p>
            </div>
          </div>

          {/* Bottom bar */}
          <div className="border-t border-background-50/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-background-50/40">
              &copy; {new Date().getFullYear()} 每日大赛mrds. 娱乐内容仅供消遣，请以官方信息为准。
            </p>
            <div className="flex items-center gap-4 text-xs text-background-50/40">
              <a href="#about" onClick={(e) => handleNavClick(e, '#about')} className="hover:text-primary-400 transition-colors cursor-pointer">关于我们</a>
              <a href="#contact" onClick={(e) => handleNavClick(e, '#contact')} className="hover:text-primary-400 transition-colors cursor-pointer">联系我们</a>
              <a href="#faq" onClick={(e) => handleNavClick(e, '#faq')} className="hover:text-primary-400 transition-colors cursor-pointer">常见问答</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}